import { Box, Stack, Typography } from "@mui/material";
import { Layout } from "../../../../containers/layout/dashboard";
import { ListOfMigrationsWrapper } from "./styled";
import { BaseButton } from "../../../../components/button/styled";
import { useNavigate } from "react-router-dom";
import { BaseTable } from "../../../../components/table";
import { useQuery } from "@tanstack/react-query";
import Cookies from "universal-cookie";
import { retrieveAllMigrationService } from "../../../../utils/apis/migration/retrieveAllMigration";
import { retrieveInstitutionService } from "../../../../utils/apis/institution/retrieveInstitution";

export const ListOfMigrations = () => {
	const headers = [
		"Institution",
		"Status",
		"Successful Tables",
		"Failed Tables",
		"Pending Tables",
	];

	const cookies = new Cookies();
	const TOKEN = cookies.getAll().TOKEN;

	const navigate = useNavigate();

	const { data: migrations } = useQuery({
		queryKey: ["all-migration", TOKEN],
		queryFn: async () => {
			const migrations = await retrieveAllMigrationService(TOKEN);
			const transformedMigrations = await Promise.all(
				migrations?.map(async (migration: any) => {
					const institution = await retrieveInstitutionService(
						TOKEN,
						migration.institution
					);
					return {
						...migration,
						institution: institution.name,
					};
				})
			);
			return transformedMigrations;
		},
		enabled: !!TOKEN,
	});

	const handleNavigateToMigrationForm = () => {
		return navigate("/migration/migratedata");
	};

	return (
		<Layout id="migration">
			<ListOfMigrationsWrapper>
				<Stack
					overflow={"hidden"}
					direction={{ tablet: "row" }}
					gap={{
						mobile: "calc(var(--flex-gap)/2)",
						tablet: "var(--flex-gap)",
					}}
					alignItems={{ tablet: "center" }}
					justifyContent={"space-between"}
					marginBlockEnd={"var(--basic-margin)"}
				>
					<Box overflow={"hidden"}>
						<Typography
							variant="h1"
							fontFamily={"Inter"}
							fontWeight={700}
							fontSize={24}
							lineHeight={"normal"}
							color={"#373737"}
							marginBlockEnd={"calc(var(--basic-margin)/4)"}
						>
							Migrations
						</Typography>
					</Box>
					<Box overflow={"hidden"}>
						<BaseButton
							variant="contained"
							radius="7px"
							fontSize={16}
							fontWeight={800}
							bgcolor="#791377"
							padding="calc(var(--basic-padding)/3) calc(var(--basic-padding) * 1.5)"
							sx={{
								width: { mobile: "-webkit-fill-available", miniTablet: "auto" },
							}}
							onClick={handleNavigateToMigrationForm}
						>
							<Typography
								variant={"button"}
								fontFamily={"inherit"}
								fontWeight={"inherit"}
								fontSize={"inherit"}
								lineHeight={"inherit"}
								color={"inherit"}
								textTransform={"inherit"}
							>
								Migrate Data
							</Typography>
						</BaseButton>
					</Box>
				</Stack>
				<BaseTable
					headers={headers}
					rows={migrations as Record<string, any>[]}
					location="all-migrations"
				/>
			</ListOfMigrationsWrapper>
		</Layout>
	);
};
